import { withStyles } from '@material-ui/core';
import React from 'react';
import StyledToolTip from '../../../../../../common/StyledToolTip';
import { getPickupStatusTypeIcon } from '../../../utils/pickupStatusTypeIcon';
import ClosingSoonBadge from '../../../../Common/ClosingSoonBadge';
import { PICKUP_STATUS } from '../../../constants';

const styles = () => ({
  container: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '28px'
  },
  pickupNumber: {
    paddingLeft: 4
  }
});

const PickupNumberRefreshed = ({
  theme,
  classes,
  timeDiff,
  pickupStatus,
  value,
  timeToCloseInMins,
  closingSoonLimitConfig
}) => {
  const getTitle = (value) => {
    switch (value) {
      case PICKUP_STATUS.newPickup:
        return `Created ${timeDiff} min(s) ago`;

      case PICKUP_STATUS.completed:
        return "Completed Pickup";

      case PICKUP_STATUS.noFreight:
        return "No Freight Pickup";

      case PICKUP_STATUS.voided:
        return "Voided Pickup";

      case PICKUP_STATUS.unacknowledged:
        return "Unacknowledged Pickup";

      case PICKUP_STATUS.future:
        return "Future Pickup";

      case PICKUP_STATUS.notCompleted:
        return "Not Completed Pickup";

      case PICKUP_STATUS.missed:
        return "Missed Pickup";

      case PICKUP_STATUS.dailyPickup:
        return "Daily Pickup";

      case PICKUP_STATUS.unassigned:
        return "Unassigned Pickup";
    
      case PICKUP_STATUS.toBeReviewed:
        return "To be Reviewed Pickup";

      default:
        return null;
    }
  };
  return (
    <div className={classes.container}>
      <StyledToolTip title={getTitle(pickupStatus)}>
        <div>{getPickupStatusTypeIcon({ status: pickupStatus, theme })}</div>
      </StyledToolTip>
      <span className={classes.pickupNumber}>{value}</span>
      <ClosingSoonBadge
        timeToCloseInMins={timeToCloseInMins}
        closingSoonLimitConfig={closingSoonLimitConfig}
      />
    </div>
  );
};

export default withStyles(styles, { withTheme: true })(PickupNumberRefreshed);
